import CebeoService from '@/services/cebeoService/CebeoService';

class StreetService {
  async searchStreet({
    postalCode,
    street
  }) {
    return CebeoService.doApiCall('post', `${process.env.VUE_APP_API}/streets/search-street`, 'searchStreet', {
      postalCode,
      street
    });
  }
}

export default new StreetService();
